// ReleaseNote7.jsx
import { Box, Typography } from "@mui/material";

const ReleaseNote7 = () => {
  return (
    <Box sx={{ backgroundColor: "#fff" }}>
      <Typography variant="h2" sx={{ mb: 2 }}>
        Release 7.0
      </Typography>

      <Typography variant="body2" sx={{ mb: 3 }}>
        Introducing new automation capabilities for reference retrieval and
        document generation workflows.
      </Typography>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          <strong>Key Updates and Enhancements</strong>
        </Typography>

        <ul style={{ margin: 0, paddingLeft: "5%" }}>
          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>
                Reference Downloader{" "}
                <span style={{ color: "green", fontSize: "0.85em", verticalAlign: "super" }}>
                  New!
                </span>
              </strong>
              <br />
              Retrieve multiple patent references through a single request and
              receive a structured, USPTO-ready output package.
              <br />
              <br />
              Key capabilities include:
              <br />
              • Bulk reference retrieval
              <br />
              • Built-in validation checks
              <br />
              • Delivery status tracking
              <br />
              • Support for English and non-English references
            </Typography>
          </li>

          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>New Form Added – Document Generation</strong>
              <br />
              <br />
              <strong>37 CFR 1.46 – Correct or Update Applicant Name<span style={{ color: "green", fontSize: "0.85em", verticalAlign: "super" }}>
                  New!
                </span>
              </strong>
              <br />
              Users can now generate the 1.46 form directly from the Document
              Generation module. The form can be generated as a standalone
              document or as part of the POA/GPOA and 37 CFR 3.73(c) workflows,
              enabling multiple related documents to be created in a single
              request.
            </Typography>
          </li>
        </ul>

        <Typography variant="body2" sx={{ mt: 1}}>
          Refer to the FAQ and Tutorial sections for more details on this feature.
        </Typography>
      </Box>
    </Box>
  );
};

export default ReleaseNote7;
